import { Heart, Users, MapPin, Star } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen" data-testid="about-page">
      {/* Hero */}
      <section className="py-20 md:py-28 bg-brand-secondary/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="font-heading text-4xl sm:text-5xl text-brand-dark leading-tight mb-6">
                Our <span className="text-brand-coral">Story</span>
              </h1>
              <p className="font-body text-lg text-brand-muted leading-relaxed mb-6">
                Comforts of Home Tulsa was born from a simple idea: every college student deserves to feel the warmth of home, even when they're miles away from their family.
              </p>
              <p className="font-body text-base text-brand-muted leading-relaxed">
                We believe that a thoughtfully curated care package can brighten a student's day, ease the stress of exams, and remind them that someone is always thinking of them.
              </p>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1670284768187-5cc68eada1b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=600"
                alt="University campus"
                className="rounded-2xl shadow-lg w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 md:py-28 bg-white" data-testid="mission-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-brand-coral/10 rounded-full flex items-center justify-center">
              <Heart size={32} className="text-brand-coral" />
            </div>
            <h2 className="font-heading text-3xl md:text-4xl text-brand-dark mb-6">
              Our Mission
            </h2>
            <p className="font-body text-lg text-brand-muted leading-relaxed mb-8">
              To strengthen the connection between parents and their college students by delivering love, comfort, and a little taste of home through carefully curated care packages.
            </p>
            <p className="font-accent text-2xl text-brand-coral">
              "Because home is where the heart is"
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-28" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-3xl md:text-4xl text-brand-dark text-center mb-16">
            What We Stand For
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-sm text-center" data-testid="value-care">
              <div className="w-14 h-14 mx-auto mb-4 bg-brand-primary/10 rounded-full flex items-center justify-center">
                <Heart size={28} className="text-brand-primary" />
              </div>
              <h3 className="font-heading text-xl text-brand-dark mb-3">Care</h3>
              <p className="font-body text-sm text-brand-muted">
                Every package is assembled with love and attention to detail.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-sm text-center" data-testid="value-community">
              <div className="w-14 h-14 mx-auto mb-4 bg-brand-coral/10 rounded-full flex items-center justify-center">
                <Users size={28} className="text-brand-coral" />
              </div>
              <h3 className="font-heading text-xl text-brand-dark mb-3">Community</h3>
              <p className="font-body text-sm text-brand-muted">
                We're proud to serve the Tulsa college community and local families.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-sm text-center" data-testid="value-local">
              <div className="w-14 h-14 mx-auto mb-4 bg-brand-secondary/30 rounded-full flex items-center justify-center">
                <MapPin size={28} className="text-brand-primary" />
              </div>
              <h3 className="font-heading text-xl text-brand-dark mb-3">Local</h3>
              <p className="font-body text-sm text-brand-muted">
                Based in Tulsa, serving students at local universities.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-sm text-center" data-testid="value-quality">
              <div className="w-14 h-14 mx-auto mb-4 bg-brand-primary/10 rounded-full flex items-center justify-center">
                <Star size={28} className="text-brand-primary" />
              </div>
              <h3 className="font-heading text-xl text-brand-dark mb-3">Quality</h3>
              <p className="font-body text-sm text-brand-muted">
                We carefully select items that students will actually use and love.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Serving */}
      <section className="py-20 md:py-28 bg-brand-dark text-white" data-testid="serving-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl mb-12">
            Proudly Serving Students At
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            <div className="bg-white/10 rounded-xl p-8 backdrop-blur-sm">
              <h3 className="font-heading text-2xl mb-2">University of Tulsa</h3>
              <p className="font-body text-brand-secondary/80">Tulsa, Oklahoma</p>
            </div>
            <div className="bg-white/10 rounded-xl p-8 backdrop-blur-sm">
              <h3 className="font-heading text-2xl mb-2">Oral Roberts University</h3>
              <p className="font-body text-brand-secondary/80">Tulsa, Oklahoma</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
